<template>
  <section class="c-gallery">
    <div class="c-gallery__wrap">
      <div class="c-gallery__slider u-margin-bottom-small swiper-container">
        <div class="c-gallery__swiper-wrapper swiper-wrapper">
          <div class="c-gallery__slide swiper-slide">
            <card-listing
              :item="items[currentSlideIndex]"
              listing-type="map"
              v-if="items[currentSlideIndex].entitytypeid === 1"
            />
            <complex-listing
              :item="items[currentSlideIndex]"
              listing-type="map"
              v-if="items[currentSlideIndex].entitytypeid === 2"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="o-retain">
      <div
        class="o-layout o-layout--gutter-base o-layout--align-middle o-layout--align-right u-margin-bottom-small"
      >
        <div class="o-layout__cell o-layout__cell--fit">
          <b class="u-milli">
            <span class="u-visually-hidden">Slide</span>
            <span>{{ nextSlideIndex }}</span>
            <span aria-hidden="true">–</span>
            <span class="u-visually-hidden">van de</span>
            <span>{{ items.length }}</span>
          </b>
        </div>
        <div class="o-layout__cell o-layout__cell--fit">
          <button-component
            modifier=" c-button--rounded  c-button--tertiary  c-button--small"
            :is-disabled="currentSlideIndex === 0"
            :hide-label="true"
            icon="chevron-left"
            :click-callback="previousSlide"
          />
        </div>
        <div class="o-layout__cell o-layout__cell--fit">
          <button-component
            modifier=" c-button--rounded  c-button--tertiary  c-button--small"
            :is-disabled="currentSlideIndex === items.length - 1"
            :hide-label="true"
            icon="chevron-right"
            :click-callback="nextSlide"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Button from '@/components/Utilities/Button.vue'
import CardListing from '@/components/Listing/CardListing.vue'
import ComplexListing from '@/components/Listing/ComplexListing.vue'

export default {
  name: 'CardSlider',
  components: {
    'button-component': Button,
    'card-listing': CardListing,
    'complex-listing': ComplexListing,
  },
  props: {
    items: Array,
  },
  data() {
    return {
      currentSlideIndex: 0,
    }
  },
  computed: {
    prevSlideIndex() {
      return this.currentSlideIndex - 1
    },
    nextSlideIndex() {
      return this.currentSlideIndex + 1
    },
  },
  methods: {
    previousSlide() {
      this.changeSlideIndex(this.prevSlideIndex)
    },
    nextSlide() {
      this.changeSlideIndex(this.nextSlideIndex)
    },
    changeSlideIndex(newIndex) {
      this.currentSlideIndex = newIndex
    },
  },
}
</script>

<style lang="scss" scoped></style>
